import { render } from "./NewStock.vue?vue&type=template&id=c77b9604"
import script from "./NewStock.vue?vue&type=script&lang=js"
export * from "./NewStock.vue?vue&type=script&lang=js"

import "./NewStock.vue?vue&type=style&index=0&id=c77b9604&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__